import React, {useState} from 'react'
import './menu.css'

export const  Menu = () => {
    const [navbar, setNavbar] = useState(false);
    return (
        <>
           <div  className='men'>
           <div className="container paddingSmall">
             <nav>
                <ul className={navbar ? "navabr" : "flex"} onClick={() => setNavbar(false)}>
                    <li><a href="#home">ACCUEIL</a></li>
                    <li><a href="#apropos">A PROPOS DE NOUS</a></li>
                    <li><a href="#services">NOS SERVICES</a></li>
                    <li><a href="#operations">NOS OPERATIONS</a></li>
                    <li><a href="#contact">CONTACT</a></li>
                </ul>
                <button className="barIco" onClick={() => setNavbar(!navbar)}>
                  {navbar ? <img src="close.png" alt='' /> : <img src="menu-bar.png" alt='' />}
                </button>
            </nav>
            </div>
           </div>
        </>
    )
  }
